
const isAuthenticatedUser = () => {
    return !!localStorage.getItem("token")
}

export { 
    isAuthenticatedUser, 
}
